import apiClient from '@/services/api-client';

export const getPurchaseInvoices = async (params) => {
    try {
        const response = await apiClient.get('/purchase/invoice/list', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
};


export const addDraftPurchaseInvoice = async () => {
    try {
        const response = await apiClient.post('/purchase/invoice/add');
        return response.data;
    } catch (error) {
        console.error('Error creating draft invoice:', error);
        throw error;
    }
};

export const getInvoiceBySpecialRef = async (specialRef) => {
    try {
        const response = await apiClient.get('/purchase/invoice/get/special-ref', {
            params: { specialRef }
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching invoice ${specialRef}:`, error);
        throw error;
    }
};

export const addInvoiceLine = async (specialRef, item) => {
    try {
        const response = await apiClient.post('/purchase/invoice/add/invoice-line', item, {
            params: { specialRef }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error adding invoice line to ${specialRef}:`, error);
        throw error;
    }
};


export const setInvoicePurchasingSupplier = async (specialRef, pSupplierId) => {
    try {
        const response = await apiClient.post('/purchase/invoice/set-purchasing-supplier', null, {
            params: { specialRef, pSupplierId }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error setting customer for invoice ${specialRef}:`, error);
        throw error;
    }
};


export const removeInvoiceLine = async (specialRef, invoiceLineId) => {
    try {
        const response = await apiClient.post('/purchase/invoice/remove/invoice-line', null, {
            params: { specialRef, invoiceLineId }
        });
        return response.data; // updated InvoiceResponseDTO
    } catch (error) {
        console.error(`Error removing invoice line ${invoiceLineId} from invoice ${specialRef}:`, error);
        throw error;
    }
};


export const addTaxes = async (specialRef, taxStamp) => {
    try {
        const response = await apiClient.post('/purchase/invoice/add/taxes', null, {
            params: { specialRef, taxStamp }
        });
        return response.data;
    } catch (error) {
        console.error(`Error adding taxes to invoice ${specialRef}:`, error);
        throw error;
    }
};


export const submitPurchaseInvoice = async (
    specialRef,
    note,
    projectName,
    invoiceExtRef,
    invoiceExtDate,
    affectsStock,
    warehouseId
) => {
    try {
        const response = await apiClient.post('/purchase/invoice/submit', null, {
            params: {
                specialRef,
                note,
                projectName,
                invoiceExtRef,
                invoiceExtDate,
                affectsStock,
                warehouseId
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting invoice:', error);
        throw error;
    }
};

export const getPurchaseWarehouses = async () => {
    const response = await apiClient.get('/purchase/invoice/warehouse/list');
    return response.data;
};


export const generateInvoiceFromQuote = async (orderId) => {
    try {
        const response = await apiClient.get('/purchase/invoice/invoiced-order',{
            params: { orderId }
        });
        return response.data;
    } catch (error) {
        console.error('Error to convert quote to invoice:', error);
        throw error;
    }
};



export const getVatRate = async () => {
    try {
        const response = await apiClient.get('/purchase/invoice/vat-rate/list');
        return response.data;
    } catch (error) {
        console.error('Error to get vat rate list :', error);
        throw error;
    }
};

export const downloadRsXmlFile = async (invoiceId) => {
  try {
    const response = await apiClient.get('/purchase/invoice/generate/rsxml', {
      params: { invoiceId },
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/xml' });

    const contentDisposition = response.headers['content-disposition'];
    let fileName = `invoice-${invoiceId}.xml`;

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+)"?/);
      if (match?.[1]) {
        fileName = match[1];
      }
    }

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error('Error downloading XML:', error);
    throw error;
  }
};


export const deleteInvoice = async (params) => {
    try {
        const response = await apiClient.get('/purchase/invoice/delete' , {params});
        return response.data;
    } catch (error) {
        console.error('Error delete draft invoice:', error);
        throw error;
    }
};
